export default __webpack_public_path__ + "static/media/Mission_POC_coordination_structure_diagram.b161e6c0.png";